import type { GeometryTableProps } from "@/scott/ui/blocks/geometry-table/geometry-table";
import { getBlockId } from "@/services/contentful/assemblies/page/adapter/utils";
import {
  UiConfigurationAdapter,
  type UiConfigurationInput,
} from "@/services/contentful/topics/UIConfiguration/ui-configuration.adapter";
import type { GeometryTablePageBlock } from "@/types/page-block";

export const columnWidthMap = {
  narrow: 8,
  medium: 10,
  wide: 12,
} as const satisfies Record<
  "narrow" | "medium" | "wide",
  NonNullable<GeometryTableProps["columnWidth"]>
>;

export interface GeometryTableInput {
  sys?: { id: string };
  __typename: "GeometryTable";
  internalName?: string | null;
  containerWidth?: keyof typeof columnWidthMap;
  showUnitToggle?: boolean | null;
  defaultUnit?: GeometryTableProps["defaultUnit"];
  frameSize?: string | null;
  title?: string | null;
  sizesIn?: string | null;
  unitMm?: string | null;
  unitInches?: string | null;
  productCodes?: string[];
  uiConfiguration?: UiConfigurationInput;
  anchorId?: string;
}

export function GeometryTableAdapter(
  item: GeometryTableInput,
  index: number
): GeometryTablePageBlock {
  const uiConfig = item.uiConfiguration
    ? UiConfigurationAdapter(item.uiConfiguration)
    : undefined;

  return {
    sys: item.sys,
    id: getBlockId(item, index),
    __typename: "GeometryTable",
    mode: "D2C",
    internalName: item.internalName ?? "Geometry Table",
    columnWidth: item.containerWidth
      ? columnWidthMap[item.containerWidth]
      : columnWidthMap.wide,
    backgroundColor: uiConfig?.backgroundColor,
    paddingTop: uiConfig?.paddingTop,
    paddingBottom: uiConfig?.paddingBottom,
    showUnitToggle: item.showUnitToggle === true,
    defaultUnit: item.defaultUnit,
    productCodes: item.productCodes,
    anchorId: item.anchorId,
    microcopies: {
      frameSize: item.frameSize ?? "Frame size",
      title: item.title ?? undefined,
      sizesIn: item.sizesIn ?? undefined,
      unitMm: item.unitMm ?? undefined,
      unitInches: item.unitInches ?? undefined,
    },
  };
}
